module.exports = __webpack_public_path__ + "static/android-chrome-256x256-db6562c2349843b82480f4896439f65e.png";